import React from 'react';
import Container from '../componants/Container';
import UserMasterContent from './userMasterDetails/UserMasterContent';

const UserMaster = () => {
  return (
    <Container>
      <UserMasterContent />
    </Container>
  );
}

export default UserMaster;